/** @jsxImportSource @emotion/react */
import { BoardTypeEnum } from 'modules/core/domain/interfaces/supabase/overlay/auxiliary-types';
import { MatchEventType } from 'shared/types/match-event';
import React, { useState } from 'react';
import UDFormInput from 'ud-form/components/input';
import UDFormSelect from 'ud-form/components/select';
import UDText from 'ud-ui/components/text';
import { CustomSelect } from './custom-select';
import Row from './row';
import { MainBlock } from './styles';
import { theme } from 'styles/theme/theme';

interface IProps {
  type: BoardTypeEnum;
}

function Type(props: IProps) {
  const [type, setType] = useState(props.type);

  return (
    <MainBlock>
      <Row headerText={'Тип табло'}>
        <UDFormSelect
          containerProps={{ style: { width: '100%' } }}
          selectComponent={CustomSelect}
          name={'type'}
          onChange={(event) => {
            setType(event?.value);
          }}
          options={typeOptions}
        />
      </Row>
      <Row headerText={'Событие'}>
        <UDFormSelect
          containerProps={{ style: { width: '100%' } }}
          selectComponent={CustomSelect}
          placeholder={'Выберите события'}
          isDisabled={type !== 'events'}
          name={'events'}
          isMulti
          options={eventsOptions}
        />
      </Row>
      <Row headerText={'Время'}>
        <UDFormInput
          containerProps={{ style: { width: '80px' } }}
          style={{ background: theme.colors.GrayF2, display: 'flex', textAlign: 'center' }}
          disabled={type !== 'events' && type !== 'carousel'}
          name={'duration'}
          type={'number'}
          placeholder={'Длительность в секундах'}
        />
        <UDText type={'subhead'} style={{ color: theme.colors.Gray96 }}>
          секунд
        </UDText>
      </Row>
    </MainBlock>
  );
}

export default Type;

export const typeOptions: { value: BoardTypeEnum; label: string }[] = [
  { label: 'Статичный', value: 'static' },
  { label: 'События', value: 'events' },
  { label: 'Карусель', value: 'carousel' },
  { label: 'Телевизор', value: 'tv' },
];

export const eventsOptions: { label: string; value: MatchEventType }[] = [
  { label: 'Гол', value: 'GOAL' },
  { label: 'Угловой', value: 'CORNER' },
  { label: 'Пас и гол', value: 'PASS_AND_GOAL' },
  { label: 'Гол в свои ворота', value: 'OWN_GOAL' },
  { label: 'Пенальти гол', value: 'PENALTY_GOAL' },
  { label: 'Пенальти промах', value: 'PENALTY_MISSED' },
  { label: 'Серия пенальти гол', value: 'AFTER_MATCH_PENALTY_GOAL' },
  { label: 'Серия пенальти промах', value: 'AFTER_MATCH_PENALTY_MISSED' },
  { label: 'Красная карточка', value: 'RED_CARD' },
  { label: 'Желтая карточка', value: 'YELLOW_CARD' },
  { label: 'Фол', value: 'FOUL' },
  { label: 'Тайм-аут', value: 'TIME_OUT' },
  { label: 'Замена', value: 'REPLACEMENT' },
  { label: 'Защита ворот', value: 'SAVE' },
];
